const isCreditDisabled = (enableCredits: boolean, date?: Date[]): boolean => {
  if (!enableCredits) {
    return true;
  }

  const selectedDate = date && date[0];

  if (!selectedDate) {
    return false;
  }
  const selectedMonth = selectedDate.getMonth();
  const currentMonth = new Date().getMonth();
  return selectedMonth !== currentMonth;
};

export default isCreditDisabled;
